import EventMenu from './event-menu';

export default EventMenu;
